export default "__VITE_ASSET__b0e48598__"